import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import beetinqiconcolorful from "../../../images/beetinq/beetinqiconcolorful.png";

const NavHader = () => {
  const { openMenuToggle } = useContext(ThemeContext);
  return (
    <div className="nav-header">
      <Link to="/dashboard" className="brand-logo">
        <img src={beetinqiconcolorful} className="img-lonca-logo mb-5 mt-5 w-30" />
      </Link>
    </div>
  );
};

export default NavHader;
